import styled from 'styled-components'
import { foldableSectionMixin } from 'builder/components/Section'

export const Container = styled.div`
  padding-top: 20px;
  ${foldableSectionMixin}
`
